export function createParticipantStateSelector(state) {
  return state.local.participants.creation
}
